import React, { useState } from 'react';
import { SaveIcon, MailIcon, ServerIcon, FileTextIcon, ShieldIcon, CheckCircleIcon } from 'lucide-react';
const Settings = () => {
  const [activeTab, setActiveTab] = useState('email');
  const [senderName, setSenderName] = useState('ekseba Uddokta');
  const [senderEmail, setSenderEmail] = useState('newsletter@ekseba.com');
  const [replyToEmail, setReplyToEmail] = useState('support@ekseba.com');
  const [smtpHost, setSmtpHost] = useState('smtp.gmail.com');
  const [smtpPort, setSmtpPort] = useState('587');
  const [smtpUsername, setSmtpUsername] = useState('newsletter@ekseba.com');
  const [smtpPassword, setSmtpPassword] = useState('');
  const [defaultTemplate, setDefaultTemplate] = useState('monthly-update');
  const [trackOpens, setTrackOpens] = useState(true);
  const [trackClicks, setTrackClicks] = useState(true);
  const [doubleOptIn, setDoubleOptIn] = useState(false);
  const tabs = [{
    id: 'email',
    name: 'Email Settings',
    icon: <MailIcon size={16} data-id="element-447" />
  }, {
    id: 'smtp',
    name: 'SMTP Configuration',
    icon: <ServerIcon size={16} data-id="element-448" />
  }, {
    id: 'templates',
    name: 'Template Defaults',
    icon: <FileTextIcon size={16} data-id="element-449" />
  }, {
    id: 'security',
    name: 'Security',
    icon: <ShieldIcon size={16} data-id="element-450" />
  }];
  return <div className="space-y-6" data-id="element-451">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-452">
        <h2 className="text-2xl font-bold text-secondary-900" data-id="element-453">Settings</h2>
        <button className="btn btn-primary flex items-center mt-3 sm:mt-0" data-id="element-454">
          <SaveIcon size={16} className="mr-1" data-id="element-455" />
          <span data-id="element-456">Save Changes</span>
        </button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-457">
        <div className="lg:col-span-1" data-id="element-458">
          <div className="card" data-id="element-459">
            <nav className="space-y-1" data-id="element-460">
              {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${activeTab === tab.id ? 'bg-primary-50 text-primary-700' : 'text-secondary-700 hover:bg-secondary-50'}`} data-id="element-461">
                  <span className="mr-3" data-id="element-462">{tab.icon}</span>
                  <span data-id="element-463">{tab.name}</span>
                </button>)}
            </nav>
          </div>
        </div>
        <div className="lg:col-span-3" data-id="element-464">
          {activeTab === 'email' && <div className="card" data-id="element-465">
              <h3 className="text-lg font-semibold text-secondary-900 mb-4" data-id="element-466">
                Email Settings
              </h3>
              <div className="space-y-4" data-id="element-467">
                <div data-id="element-468">
                  <label htmlFor="senderName" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-469">
                    Sender Name *
                  </label>
                  <input id="senderName" type="text" value={senderName} onChange={e => setSenderName(e.target.value)} placeholder="Enter sender name" className="input" required data-id="element-470" />
                  <p className="text-xs text-secondary-500 mt-1" data-id="element-471">
                    This name will appear in the "From" field of your emails
                  </p>
                </div>
                <div data-id="element-472">
                  <label htmlFor="senderEmail" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-473">
                    Sender Email *
                  </label>
                  <input id="senderEmail" type="email" value={senderEmail} onChange={e => setSenderEmail(e.target.value)} placeholder="Enter sender email" className="input" required data-id="element-474" />
                  <p className="text-xs text-secondary-500 mt-1" data-id="element-475">
                    This email address will appear in the "From" field
                  </p>
                </div>
                <div data-id="element-476">
                  <label htmlFor="replyToEmail" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-477">
                    Reply-To Email
                  </label>
                  <input id="replyToEmail" type="email" value={replyToEmail} onChange={e => setReplyToEmail(e.target.value)} placeholder="Enter reply-to email" className="input" data-id="element-478" />
                  <p className="text-xs text-secondary-500 mt-1" data-id="element-479">
                    Replies will be sent to this email address
                  </p>
                </div>
                <div className="pt-4 border-t border-secondary-200" data-id="element-480">
                  <h4 className="text-sm font-medium text-secondary-900 mb-3" data-id="element-481">
                    Email Tracking
                  </h4>
                  <div className="space-y-3" data-id="element-482">
                    <div className="flex items-center justify-between" data-id="element-483">
                      <div data-id="element-484">
                        <p className="text-sm font-medium text-secondary-900" data-id="element-485">
                          Track Email Opens
                        </p>
                        <p className="text-xs text-secondary-500" data-id="element-486">
                          Track when recipients open your emails
                        </p>
                      </div>
                      <button type="button" className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${trackOpens ? 'bg-primary-600' : 'bg-secondary-200'}`} onClick={() => setTrackOpens(!trackOpens)} data-id="element-487">
                        <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${trackOpens ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-488" />
                      </button>
                    </div>
                    <div className="flex items-center justify-between" data-id="element-489">
                      <div data-id="element-490">
                        <p className="text-sm font-medium text-secondary-900" data-id="element-491">
                          Track Link Clicks
                        </p>
                        <p className="text-xs text-secondary-500" data-id="element-492">
                          Track when recipients click links in your emails
                        </p>
                      </div>
                      <button type="button" className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${trackClicks ? 'bg-primary-600' : 'bg-secondary-200'}`} onClick={() => setTrackClicks(!trackClicks)} data-id="element-493">
                        <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${trackClicks ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-494" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {activeTab === 'smtp' && <div className="card" data-id="element-495">
              <h3 className="text-lg font-semibold text-secondary-900 mb-4" data-id="element-496">
                SMTP Configuration
              </h3>
              <div className="space-y-4" data-id="element-497">
                <div className="p-3 bg-blue-50 border border-blue-200 rounded-md" data-id="element-498">
                  <p className="text-sm text-blue-800" data-id="element-499">
                    Configure your SMTP server to send emails. Make sure your
                    SMTP credentials are correct to avoid delivery issues.
                  </p>
                </div>
                <div data-id="element-500">
                  <label htmlFor="smtpHost" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-501">
                    SMTP Host *
                  </label>
                  <input id="smtpHost" type="text" value={smtpHost} onChange={e => setSmtpHost(e.target.value)} placeholder="smtp.example.com" className="input" required data-id="element-502" />
                </div>
                <div data-id="element-503">
                  <label htmlFor="smtpPort" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-504">
                    SMTP Port *
                  </label>
                  <input id="smtpPort" type="text" value={smtpPort} onChange={e => setSmtpPort(e.target.value)} placeholder="587" className="input" required data-id="element-505" />
                  <p className="text-xs text-secondary-500 mt-1" data-id="element-506">
                    Common ports: 587 (TLS), 465 (SSL), 25 (unsecured)
                  </p>
                </div>
                <div data-id="element-507">
                  <label htmlFor="smtpUsername" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-508">
                    SMTP Username *
                  </label>
                  <input id="smtpUsername" type="text" value={smtpUsername} onChange={e => setSmtpUsername(e.target.value)} placeholder="Enter SMTP username" className="input" required data-id="element-509" />
                </div>
                <div data-id="element-510">
                  <label htmlFor="smtpPassword" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-511">
                    SMTP Password *
                  </label>
                  <input id="smtpPassword" type="password" value={smtpPassword} onChange={e => setSmtpPassword(e.target.value)} placeholder="Enter SMTP password" className="input" required data-id="element-512" />
                </div>
                <div className="pt-4" data-id="element-513">
                  <button className="btn btn-outline" data-id="element-514">
                    Test SMTP Connection
                  </button>
                </div>
              </div>
            </div>}
          {activeTab === 'templates' && <div className="card" data-id="element-515">
              <h3 className="text-lg font-semibold text-secondary-900 mb-4" data-id="element-516">
                Template Defaults
              </h3>
              <div className="space-y-4" data-id="element-517">
                <div data-id="element-518">
                  <label htmlFor="defaultTemplate" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-519">
                    Default Template
                  </label>
                  <select id="defaultTemplate" value={defaultTemplate} onChange={e => setDefaultTemplate(e.target.value)} className="input" data-id="element-520">
                    <option value="monthly-update" data-id="element-521">Monthly Update</option>
                    <option value="welcome-series" data-id="element-522">Welcome Series</option>
                    <option value="promotional" data-id="element-523">Promotional</option>
                    <option value="event-invitation" data-id="element-524">Event Invitation</option>
                  </select>
                  <p className="text-xs text-secondary-500 mt-1" data-id="element-525">
                    This template will be pre-selected when creating new
                    newsletters
                  </p>
                </div>
                <div className="pt-4 border-t border-secondary-200" data-id="element-526">
                  <h4 className="text-sm font-medium text-secondary-900 mb-3" data-id="element-527">
                    Footer Settings
                  </h4>
                  <div className="space-y-3" data-id="element-528">
                    <div data-id="element-529">
                      <label htmlFor="companyName" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-530">
                        Company Name
                      </label>
                      <input id="companyName" type="text" defaultValue="ekseba Uddokta" className="input" data-id="element-531" />
                    </div>
                    <div data-id="element-532">
                      <label htmlFor="companyAddress" className="block text-sm font-medium text-secondary-700 mb-1" data-id="element-533">
                        Company Address
                      </label>
                      <textarea id="companyAddress" rows={3} defaultValue="123 Business Street, Dhaka, Bangladesh" className="input" data-id="element-534" />
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {activeTab === 'security' && <div className="card" data-id="element-535">
              <h3 className="text-lg font-semibold text-secondary-900 mb-4" data-id="element-536">
                Security Settings
              </h3>
              <div className="space-y-4" data-id="element-537">
                <div className="flex items-center justify-between" data-id="element-538">
                  <div data-id="element-539">
                    <p className="text-sm font-medium text-secondary-900" data-id="element-540">
                      Double Opt-In
                    </p>
                    <p className="text-xs text-secondary-500" data-id="element-541">
                      Require subscribers to confirm their email address
                    </p>
                  </div>
                  <button type="button" className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${doubleOptIn ? 'bg-primary-600' : 'bg-secondary-200'}`} onClick={() => setDoubleOptIn(!doubleOptIn)} data-id="element-542">
                    <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${doubleOptIn ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-543" />
                  </button>
                </div>
                <div className="pt-4 border-t border-secondary-200" data-id="element-544">
                  <div className="p-3 bg-green-50 border border-green-200 rounded-md flex items-start" data-id="element-545">
                    <CheckCircleIcon size={20} className="text-green-600 mr-3 mt-0.5" data-id="element-546" />
                    <div data-id="element-547">
                      <p className="text-sm font-medium text-green-900" data-id="element-548">
                        GDPR Compliant
                      </p>
                      <p className="text-xs text-green-700 mt-1" data-id="element-549">
                        Your newsletter system is configured to comply with GDPR
                        regulations
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
export default Settings;